<template>
  <b-container fluid class="theme-yellow">
    <div class="page-header">
      <Navbar text="Companion" />
    </div>
    
    <section>
      <div class="row">
        <div class="col-sm-6">
          <h2>
            Models
            <StorageStatus
              :stored="modelsCount"
              :limit="modelsLimit"
            />
          </h2>
        </div>
        <div class="col-sm-6 text-right">
          <div style="display: inline; margin-right: 10px;">
            <b-button-group>
              <b-button variant="danger" :disabled="!modelsSelected" @click="removeSelectedModels()">
                Remove {{ this.selectedModelsCount > 0 ? "(" + this.selectedModelsCount + ")" : ""}}
              </b-button>
            </b-button-group>
          </div>
          <b-button variant="primary" v-b-modal.upload-model-modal :disabled="!canUploadModel">
            Upload
          </b-button>
        </div>
      </div>
      
      
      <ModelsDeck
        ref="modelsDeck"
        v-if="isLoggedIn"
        :storage-type="storageType"
        v-on:models-loaded="onModelsGridModelsLoaded"
        v-on:models-toggled="onModelsToggled"
      />

      <b-modal
        :id="MODAL_ID_UPLOAD"
        size="lg"
        centered
        role="dialog"
        modal-class="regular"
        hide-header-close
        hide-footer
      >
        <template slot="modal-header" slot-scope="{ close }">
          <h5 class="modal-title">Upload Model</h5>
          <button
            type="button"
            class="close"
            @click="close()"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </template>
        <template slot="default">
          <UploadModel
            :storage-type="storageType"
            formats=".gltf,.glb,.fbx"
            v-on:model-uploaded="onModelUploaded"
          />
        </template>
      </b-modal>
    </section>
  </b-container>
</template>

<script>
import Navbar from "@/components/Navigation/Navbar";
import ModelsGrid from "@/components/Views/ModelsGrid";
import ModelsDeck from "@/components/Views/ModelsDeck";
import UploadModel from "@/components/Views/UploadModel";
import StorageStatus from "@/components/Views/StorageStatus";
import * as harpraApi from "@/services/api.service";
import * as routerUtils from "@/utils/router-utils";
import { mapGetters } from "vuex";

export default {
  name: "BrochureModules",
  components: {
    Navbar,
    ModelsGrid,
    ModelsDeck,
    UploadModel,
    StorageStatus,
  },
  data() {
    return {
      MODAL_ID_UPLOAD: "upload-model-modal",
      storageType: harpraApi.StorageType.Companion,
      isSubscriptionActive: false,
      modelsCount: null,
      modelsLimit: null,
      canUploadModel: false,
      selectedModelsCount: 0
    };
  },
  computed: {
    ...mapGetters([ "isLoggedIn", "subscriptionInfo" ]),
    modelsSelected () {
      return this.selectedModelsCount > 0;
    }
  },
  methods: {
    onModelsGridModelsLoaded: function (models) {
      this.modelsCount = models.length;
      this.canUploadModel = this.modelsCount < this.modelsLimit;
    },
    onModelsToggled: function(selectedCount) {
      this.selectedModelsCount = selectedCount;
    },
    async removeSelectedModels() {
      await this.$refs.modelsDeck.removeSelectedModels();
    },
    async onModelUploaded() {
      await this.$refs.modelsDeck.loadModels();
    },
  },
  created() {
    this.$AuthService.getAccessToken(
      async () => {
        try {
          let subscriptionInfo = await harpraApi.getSubscriptionInfo(this.$AuthService.token.accessToken);

          this.isSubscriptionActive = subscriptionInfo.isActive;
          this.modelsLimit = subscriptionInfo.companionModelsLimit;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log("[WARN ] Couldn't get subscription info.");

          this.isSubscriptionActive = false;
        }

        if (!this.isSubscriptionActive) {
          routerUtils.routeToAccount(this);
        }
      },
      () => {
        // eslint-disable-next-line no-console
        console.log("[ERROR] Couldn't get access token in created().");
      }
    );
  },
};
</script>
